import { Box } from "@mui/material";

// Shared filter chip used by every coach-dashboard tab's *Filters row (Weight, Steps,
// Nutrition, …). Was previously copy-pasted byte-for-byte in each tab file. A dashed
// border means inactive, a solid tinted border means active.
const FilterChip = ({ active, onClick, color, label }) => (
  <Box
    component="button"
    onClick={onClick}
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: "5px",
      padding: "4px 11px",
      borderRadius: "20px",
      border: `1px ${active ? "solid" : "dashed"} ${color}`,
      background: active ? `${color}1A` : "transparent",
      color,
      fontSize: "11.5px",
      fontWeight: 600,
      cursor: "pointer",
      fontFamily: "inherit",
      transition: "all .13s",
    }}
  >
    {label}
  </Box>
);

export default FilterChip;
